// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"792c9eb8","732":"2333145a","977":"43b836a3"}[chunkId] + ".chunk.js";
};